import React, {useState, useEffect} from 'react'
import Navbar from '../../Components/Navbar/Navbar'
// import toast from 'react-hot-toast';
import EditableScoreCard from '../../Components/EditableScoreCard'
import { 
    Layout,
    Col, 
    Row,
    Select,
    Button,
    Tabs,
    Space,
    Table,
} from 'antd';
import { 
  ArrowBack,
} from '@mui/icons-material';
import { 
  useNavigate,
  useParams,
 } from "react-router-dom"
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
// import { refreshPage } from '../../Utils/Common';

const { TabPane } = Tabs;
const { Option } = Select;

const FourManThreeCountScoreCard = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [playerData, setPlayerData] = useState([])
  const [dayOneData, setDayOneData] = useState([])
  const [playerDivision, setPlayerDivision] = useState('');
  const [playerId, setPlayerId] = useState('')
  // const [pageSize, setPageSize] = useState('');

  const [filterConfig, setFilterConfig] = useState({
    directors_cup_player: '',
    page: 1,
    tournament_id: id,
  })
  const { callPost, data } = usePostRequest(()=>{
    // refreshPage()
  });
  const dataHeader = [
    {
      key: '1',
      name: 'HOLES',
      score_1: 1,
      score_2: 2,
      score_3: 3,
      score_4: 4,
      score_5: 5,
      score_6: 6,
      score_7: 7,
      score_8: 8,
      score_9: 9,
      out: 'OUT',
      score_10: 10,
      score_11: 11,
      score_12: 12,
      score_13: 13,
      score_14: 14,
      score_15: 15,
      score_16: 16,
      score_17: 17,
      score_18: 18,
      in: 'IN',
      gross: 'GROSS',
      hdc: "HDC",
      points_total: "NET",
      isClickable: true,
    },
    {
      key: '2',
      name: 'PAR',
      score_1: 4,
      score_2: 3,
      score_3: 4,
      score_4: 4,
      score_5: 4,
      score_6: 3,
      score_7: 5,
      score_8: 3,
      score_9: 5,
      out: '35',
      score_10: 5,
      score_11: 4,
      score_12: 4,
      score_13: 3,
      score_14: 4,
      score_15: 3,
      score_16: 5,
      score_17: 4,
      score_18: 5,
      in: '37',
      gross: '72',
      hdc: '',
      isClickable: true,
    },
    {
      key: '3',
      name: 'HANDICAP (WHITE/RED)',
      score_1: 6,
      score_2: 18,
      score_3: 12,
      score_4: 8,
      score_5: 4,
      score_6: 16,
      score_7: 10,
      score_8: 4,
      score_9: 2,
      out: '',
      score_10: 1,
      score_11: 5,
      score_12: 9,
      score_13: 17,
      score_14: 11,
      score_15: 7,
      score_16: 3,
      score_17: 15,
      score_18: 13,
      in: '',
      hdc: "",
      isClickable: true,
    },
    // { 
    //   key: 'custom-row',
    // }
  ];

  async function fetchPlayerData() {
    setIsLoading(true)
    const response = await UseGetRequest("directors_cup_players/get_players_by_team", filterConfig);
    if (response?.data) {
      setPlayerData(response?.data?.data);
      // setPageSize(response?.data?.size)
    } else {
      setPlayerData([])
    }

    setIsLoading(false);
  }

  const handleAddOk = () => {
    const filter_one = dayOneData.filter(item => item.player_id);
    // const filter_two = dayTwoData.filter(item => item.player_id)
    const data = {
      // team_name: filter_one.map((item)=>item.team_name),
      player_id: filter_one[0].player_id,
      gross_1: filter_one[0].score_1,
      gross_2: filter_one[0].score_2,
      gross_3: filter_one[0].score_3,
      gross_4: filter_one[0].score_4,
      gross_5: filter_one[0].score_5,
      gross_6: filter_one[0].score_6,
      gross_7: filter_one[0].score_7,
      gross_8: filter_one[0].score_8,
      gross_9: filter_one[0].score_9,
      gross_10: filter_one[0].score_10,
      gross_11: filter_one[0].score_11,
      gross_12: filter_one[0].score_12,
      gross_13: filter_one[0].score_13,
      gross_14: filter_one[0].score_14,
      gross_15: filter_one[0].score_15,
      gross_16: filter_one[0].score_16,
      gross_17: filter_one[0].score_17,
      gross_18: filter_one[0].score_18,
    };
    var finalValues = Object.entries(data).map(([key, value]) => ({
        key,
        value,
    }));
    callPost(
        "directors_cup_scores/create_individual", 
        finalValues,
        true
    );
  };

  async function fetchTeamData(id) {
    setIsLoading(true);
    setDayOneData([]);
    // setDayTwoData([])
    const response = await UseGetRequest("directors_cup_scores/get", { directors_cup_player_id: id, tournament_id: filterConfig.tournament_id });
    if (response?.data) {
      const player_score = response?.data?.data?.map((data, index) => ({
        gross:{ 
          name: 'GROSS',
          key: 4,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.gross_1,
          score_2: data.gross_2,
          score_3: data.gross_3,
          score_4: data.gross_4,
          score_5: data.gross_5,
          score_6: data.gross_6,
          score_7: data.gross_7,
          score_8: data.gross_8,
          score_9: data.gross_9,
          score_10: data.gross_10,
          score_11: data.gross_11,
          score_12: data.gross_12,
          score_13: data.gross_13,
          score_14: data.gross_14,
          score_15: data.gross_15,
          score_16: data.gross_16,
          score_17: data.gross_17,
          score_18: data.gross_18,
          gross: data.gross,
          hdc: data.hdc,
          in: data.gross_in,
          out: data.gross_out,
          day1_adj_hdc: data.day1_adj_hdc,
        },
        net:{ 
          name: 'NET SCORE',
          key: 5,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.net_1,
          score_2: data.net_2,
          score_3: data.net_3,
          score_4: data.net_4,
          score_5: data.net_5,
          score_6: data.net_6,
          score_7: data.net_7,
          score_8: data.net_8,
          score_9: data.net_9,
          score_10: data.net_10,
          score_11: data.net_11,
          score_12: data.net_12,
          score_13: data.net_13,
          score_14: data.net_14,
          score_15: data.net_15,
          score_16: data.net_16,
          score_17: data.net_17,
          score_18: data.net_18,
          net: data.net,
          hdc: '',
          in: data.net_in,
          out: data.net_out,
          isClickable: true,
        },
        points:{ 
          name: 'NET POINTS',
          key: 6,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.points_1,
          score_2: data.points_2,
          score_3: data.points_3,
          score_4: data.points_4,
          score_5: data.points_5,
          score_6: data.points_6,
          score_7: data.points_7,
          score_8: data.points_8,
          score_9: data.points_9,
          score_10: data.points_10,
          score_11: data.points_11,
          score_12: data.points_12,
          score_13: data.points_13,
          score_14: data.points_14,
          score_15: data.points_15,
          score_16: data.points_16,
          score_17: data.points_17,
          score_18: data.points_18,
          points: data.points,
          points_total: data.points,
          hdc: '',
          in: data.points_in,
          out: data.points_out,
          isClickable: true,
        }
      }))
      const dayOne = player_score.map((player) => player.gross);    
      const netOne = player_score.map((player) => player.net);    
      const pointOne = player_score.map((player) => player.points);    
      setDayOneData(() => [
        ...dataHeader,
        ...dayOne,
        ...netOne,
        ...pointOne,
      ]);
    } else {
      const response2 = await UseGetRequest("directors_cup_players/get_player", { directors_cup_player_id: id });
      if(response2.data) {
        const day = {}
        for (let i=0; i<18; i++) {
          day[`score_${i+1}`] = ''
        }
        const player_data = response2?.data?.data?.map((data, index) => ({
          day1: {
            hdc: data.hdc,
            player_id: data.player_id,
            name: "GROSS",
            key: index + 1,
            ...day,
          }
        }))
        const dayOne = player_data.map((player) => player.day1);
        setDayOneData(() => [
          ...dataHeader,
          ...dayOne,

        ]);

      } else {
        setDayOneData([]);
      }
    }
    setIsLoading(false);
  };

  const headerColumns = [
    {
      title: ' ',
      dataIndex: 'division_name',
      key: 'division_name',
      align: 'center',
      width: '25vw',
      onCell: () => ({
        editable: false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'name',
      key: 'name',
    }
  ];

  const columns = [
    {
      title: ' ',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      width: '25vw',
      onCell: () => ({
        editable: false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_1',
      key: 'score',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_2',
      key: 'score',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_3',
      key: 'score',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_4',
      key: 'score_4',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_5',
      key: 'score_5',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_6',
      key: 'score_6',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_7',
      key: 'score_7',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_8',
      key: 'score_8',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_9',
      key: 'score_9',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'out',
      key: 'out',
      // onCell: (record) => ({
      //   editable: !record.isClickable ? true : false
      // })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_10',
      key: 'score_10',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_11',
      key: 'score_11',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_12',
      key: 'score_12',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_13',
      key: 'score_13',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_14',
      key: 'score_14',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_15',
      key: 'score_15',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_16',
      key: 'score_16',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_17',
      key: 'score_17',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'score_18',
      key: 'score_18',
      onCell: (record) => ({
        editable: !record.isClickable ? true : false
      })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'in',
      key: 'in',
      // onCell: (record) => ({
      //   editable: !record.isClickable ? true : false
      // })
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'gross',
      key: 'gross',
    },
    {
      title: '',
      align: 'center',
      dataIndex: 'hdc',
      key: 'hdc',
    },
  
    {
      title: '',
      align: 'center',
      dataIndex: 'points_total',
      key: 'points_total',
    },
  
  ];

  const onChange = (activeKey) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        status:  activeKey
      }
    ));
  };
  const handlePlayerScore = (player_id) => {
    const data = playerData?.filter(item => item.id === player_id);

    setPlayerDivision(data[0])
    setPlayerId(playerId)
    fetchTeamData(player_id)
  }


  const CustomRow = ({ children, record, ...props }) => {
    if (props['data-row-key'] === 'custom-row') {  
      return (
        <tr {...props}>
          <td colSpan={1} className='custom-name'>
            <div className='center'>
              { playerDivision }
            </div>
          </td>
          <td colSpan={22} className='custom-data'>
            <div className='center'>
              GROSS
            </div>
          </td>
        </tr>
      );
    }
    return <tr {...props}>{children}</tr>;
  };

  const components = {
    body: {
      row: (props) => <CustomRow {...props} />,
    },
  };

  useEffect(() => {
    fetchPlayerData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if(data){
      const player_score = data?.data?.map((data) => ({
        gross:{ 
          name: 'GROSS',
          key: 4,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.gross_1,
          score_2: data.gross_2,
          score_3: data.gross_3,
          score_4: data.gross_4,
          score_5: data.gross_5,
          score_6: data.gross_6,
          score_7: data.gross_7,
          score_8: data.gross_8,
          score_9: data.gross_9,
          score_10: data.gross_10,
          score_11: data.gross_11,
          score_12: data.gross_12,
          score_13: data.gross_13,
          score_14: data.gross_14,
          score_15: data.gross_15,
          score_16: data.gross_16,
          score_17: data.gross_17,
          score_18: data.gross_18,
          gross: data.gross,
          hdc: data.hdc,
          in: data.gross_in,
          out: data.gross_out,
          day1_adj_hdc: data.day1_adj_hdc,
        },
        net:{ 
          name: 'NET SCORE',
          key: 5,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.net_1,
          score_2: data.net_2,
          score_3: data.net_3,
          score_4: data.net_4,
          score_5: data.net_5,
          score_6: data.net_6,
          score_7: data.net_7,
          score_8: data.net_8,
          score_9: data.net_9,
          score_10: data.net_10,
          score_11: data.net_11,
          score_12: data.net_12,
          score_13: data.net_13,
          score_14: data.net_14,
          score_15: data.net_15,
          score_16: data.net_16,
          score_17: data.net_17,
          score_18: data.net_18,
          net: data.net,
          hdc: data.hdc,
          in: data.net_in,
          out: data.net_out,
          isClickable: true,
        },
        points:{ 
          name: 'POINTS',
          key: 6,
          player_id: data.player_id,
          player_name: data.player_name,
          team_name: data.team_name,
          score_1: data.points_1,
          score_2: data.points_2,
          score_3: data.points_3,
          score_4: data.points_4,
          score_5: data.points_5,
          score_6: data.points_6,
          score_7: data.points_7,
          score_8: data.points_8,
          score_9: data.points_9,
          score_10: data.points_10,
          score_11: data.points_11,
          score_12: data.points_12,
          score_13: data.points_13,
          score_14: data.points_14,
          score_15: data.points_15,
          score_16: data.points_16,
          score_17: data.points_17,
          score_18: data.points_18,
          points: data.points,
          hdc: data.hdc,
          in: data.points_in,
          out: data.points_out,
          points_total: data.points,
          isClickable: true,
        }
      }))
      const dayOne = player_score.map((player) => player.gross);    
      const netOne = player_score.map((player) => player.net);    
      const pointOne = player_score.map((player) => player.points);    
      setDayOneData(() => [
        ...dataHeader,
        ...dayOne,
        ...netOne,
        ...pointOne,
      ]);
    } else {
      setDayOneData([])
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Layout className='page'>
      <Navbar navKey={'three_to_count_nav'} />
      <Layout className='content-container overflow-y'>
        <Row className='custom-padding responsive-tab-inline'>
          <Col span={15} className='header-container'>
            <Space>
              <ArrowBack className='cursor' onClick={() => navigate('/fourman/player/' + id)}/>
              SCORECARD
            </Space>
          </Col>
        </Row>
        <Row>
          <Col span={24} className='px-4'>
            <Select 
              style={{width:'50%'}}
              size='large'
              placeholder="Select Team" 
              onChange={(e) => handlePlayerScore(e)}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {playerData?.map((option) => (
                  <Option key={option.id} value={option.id}>{option.name}</Option>
              ))}
            </Select>    
          </Col>
        </Row>
        <Row className="page-content">
          <Col span={24}>
            <Tabs 
              defaultActiveKey="all" 
              type="card" 
              activeKey={filterConfig?.status}
              className="custom-tabs"
              onChange={onChange}
            >
              <TabPane tab="Day 1" key="day_one">
                {
                  dayOneData.length !== 0 && (
                    <Table
                      components={components}
                      bordered
                      dataSource={[playerDivision]}
                      columns={headerColumns}
                      pagination={false}
                      showHeader={false}
                      rowClassName='div-table'
                    />
                  )
                }
                <EditableScoreCard 
                  dataSource={dayOneData} 
                  setDataSource={setDayOneData} 
                  columns={columns} 
                  loading={isLoading}
                />
              </TabPane>
              {/* <TabPane tab="Day 2" key="day_two">
                <EditableScoreCard 
                  dataSource={dayTwoData} 
                  setDataSource={setDayTwoData} 
                  columns={columns} 
                  loading={isLoading}
                />
              </TabPane> */}
            </Tabs>
          </Col>
        </Row>
        <Row>
          <Col span={18}></Col>
          <Col align='right' span={6} className='px-4'>
            <Button className='edit-btn' onClick={handleAddOk}>
              Save
            </Button>
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
};

export default FourManThreeCountScoreCard;